export default __webpack_public_path__ + "static/media/work2image3.ee2957ac.png";